import React from 'react';
import { enableMapSet } from 'immer';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from 'App';
import Analytics from 'pages/Analytics';
import reportWebVitals from 'reportWebVitals';

enableMapSet();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }

        return failureCount < 3;
      },
    },
  },
});

let initialized = false;

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>

      <Analytics />
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
const tagManagerArgs = {
  gtmId: 'GTM-KS8CMT2',
};
if (!initialized) {
  TagManager.initialize(tagManagerArgs);
  initialized = true;
}
